import { type RouteRecordRaw } from 'vue-router';

import { ROUTE_DATA } from '@/constants/routes.constants';

const Account = (): unknown => {
    return import(/* webpackPrefetch: true */ './account-page.vue');
};

export const accountRoute: RouteRecordRaw = {
    ...ROUTE_DATA.ACCOUNT_PAGE,
    components: {
        main: Account
    },
    meta: {
        noMenu: true
    }
};
